import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormService } from 'app/services/form.service';

@Component({
  selector: 'app-chemicals-attached',
  templateUrl: './chemicals-attached.component.html',
  styleUrls: ['./chemicals-attached.component.scss']
})
export class ChemicalsAttachedComponent implements OnInit {

  @ViewChild('chemicalsAttachedInput') chemicalsAttachedInput!: ElementRef;
  chemicalsAttached!: string;

  constructor(private formService: FormService) {}

  ngOnInit(): void {
    this.chemicalsAttached = this.currentForm.get('chemicalsAttached')?.value;
  }

  public clearChemicalsAttachedInputField() {
    this.chemicalsAttached = '';
    this.currentForm.patchValue({'chemicalsAttached': ''});
  }

  public updateChemicalsAttached(event: Event) {
    if(event && event.type === 'blur') {
      var target = document.activeElement;
      if(target && target.nodeValue === "cancel") {
        this.chemicalsAttached = '';
      }
    }
    this.currentForm.patchValue({'chemicalsAttached': this.chemicalsAttached});
  }

  public cancelUpdate() {
    this.chemicalsAttached = this.currentForm.get('chemicalsAttached')?.value;
  }

  get currentForm(): FormGroup {
    return this.formService.getCurrentUsanFormValue();
  }

}
